module.exports = __webpack_public_path__ + "static/media/fileImageSvgrepo.0c131ffd.svg";